import {
  EMP_REQUEST,
  EMP_SUCCESS,
  EMP_FAIL,
  EMP_CLEAR_ERRORS,
  UPDATE_EMP_CLEAR_ERRORS,
  UPDATE_EMP_FAIL,
  UPDATE_EMP_REQUEST,
  UPDATE_EMP_SUCCESS,
  EMP_IMPORT_REQUEST,
  EMP_IMPORT_SUCCESS,
  EMP_IMPORT_FAIL,
  EMP_IMPORT_CLEAR_ERRORS,

  // employee search
  EMP_SEARCH_REQUEST,
  EMP_SEARCH_SUCCESS,
  EMP_SEARCH_FAIL,
  EMP_SEARCH_CLEAR_ERRORS,

  // employee search by designation and department wise
  EMP_BY_REQUEST,
  EMP_BY_SUCCESS,
  EMP_BY_FAIL,
  EMP_BY_CLEAR_ERRORS,

  EMP_BY_ID_REQUEST,
  EMP_BY_ID_SUCCESS,
  EMP_BY_ID_FAIL,
  EMP_BY_ID_CLEAR_ERRORS,

  LOCK_REQUEST, LOCK_SUCCESS, LOCK_FAIL, LOCK_CLEAR_ERRORS
} from "../Constants/employees_constants";

export const employees_reducer = (
  state = {
    employees: [],
  },
  action
) => {
  switch (action.type) {
    case EMP_REQUEST:
      return {
        loading: true,
        employees: [],
      };
    case EMP_SUCCESS:
      return {
        loading: false,
        employees: action.payload.data.result,
      };
    case EMP_FAIL:
      return {
        loading: false,
        employees: null,
        employees_error: action.payload,
      };

    case EMP_CLEAR_ERRORS:
      return {
        ...state,
        employees_error: null,
      };
    default:
      return state;
  }
};

export const update_emp_reducer = (
  state = {
    update_emp: [],
  },
  action
) => {
  switch (action.type) {
    case UPDATE_EMP_REQUEST:
      return {
        loading: true,
        update_emp: [],
      };
    case UPDATE_EMP_SUCCESS:
      return {
        loading: false,
        update_emp: action.payload.data,
        is_updated_emp: true,
      };
    case UPDATE_EMP_FAIL:
      return {
        loading: false,
        update_emp: null,
        update_emp_error: action.payload,
        is_updated_emp: false,
      };

    case UPDATE_EMP_CLEAR_ERRORS:
      return {
        ...state,
        update_emp_error: null,
      };
    default:
      return state;
  }
};

export const bulk_emp_reducer = (
  state = {
    bulk_emp: [],
  },
  action
) => {
  switch (action.type) {
    case EMP_IMPORT_REQUEST:
      return {
        loading: true,
        bulk_emp: [],
      };
    case EMP_IMPORT_SUCCESS:
      return {
        loading: false,
        bulk_emp: action.payload.data,
        import_fail: false,
      };
    case EMP_IMPORT_FAIL:
      return {
        loading: false,
        bulk_emp: null,
        bulk_emp_error: action.payload,
        import_fail: true,
      };

    case EMP_IMPORT_CLEAR_ERRORS:
      return {
        ...state,
        bulk_emp_error: null,
        import_fail: false,
      };
    default:
      return state;
  }
};

export const search_employees_reducer = (
  state = {
    search_employees: [],
  },
  action
) => {
  switch (action.type) {
    case EMP_SEARCH_REQUEST:
      return {
        search_employees_loading: true,
        search_employees: [],
      };
    case EMP_SEARCH_SUCCESS:
      return {
        search_employees_loading: false,
        search_employees: action.payload,
      };
    case EMP_SEARCH_FAIL:
      return {
        search_employees_loading: false,
        search_employees: null,
        search_employees_error: action.payload,
      };

    case EMP_SEARCH_CLEAR_ERRORS:
      return {
        ...state,
        search_employees_error: null,
      };
    default:
      return state;
  }
};

// by designation and department
export const search_employees_by_reducer = (
  state = {
    search_employees_by: [],
  },
  action
) => {
  switch (action.type) {
    case EMP_BY_REQUEST:
      return {
        search_employees_by_loading: true,
        search_employees_by: [],
      };
    case EMP_BY_SUCCESS:
      return {
        search_employees_by_loading: false,
        search_employees_by: action.payload,
      };
    case EMP_BY_FAIL:
      return {
        search_employees_by_loading: false,
        search_employees_by: null,
        search_employees_by_error: action.payload,
      };

    case EMP_BY_CLEAR_ERRORS:
      return {
        ...state,
        search_employees_by_error: null,
      };
    default:
      return state;
  }
};


export const search_employees_by_id_reducer = (
  state = {
    search_employees_by_id: [],
  },
  action
) => {
  switch (action.type) {
    case EMP_BY_ID_REQUEST:
      return {
        search_employees_by_id_loading: true,
        search_employees_by_id: [],
      };
    case EMP_BY_ID_SUCCESS:
      return {
        search_employees_by_id_loading: false,
        search_employees_by_id: action.payload,
      };
    case EMP_BY_ID_FAIL:
      return {
        search_employees_by_id_loading: false,
        search_employees_by_id: null,
        search_employees_by_id_error: action.payload,
      };

    case EMP_BY_ID_CLEAR_ERRORS:
      return {
        ...state,
        search_employees_by_id_error: null,
      };
    default:
      return state;
  }
};


export const lock_reducer = (
  state = {
    lock: [],
  },
  action
) => {
  switch (action.type) {
    case LOCK_REQUEST:
      return {
        lock_loading: true,
        lock: [],
      };
    case LOCK_SUCCESS:
      return {
        lock_loading: false,
        lock: action.payload,
      };
    case LOCK_FAIL:
      return {
        lock_loading: false,
        lock: null,
        lock_error: action.payload,
      };

    case LOCK_CLEAR_ERRORS:
      return {
        ...state,
        lock_error: null,
      };
    default:
      return state;
  }
};